<template>
  <!-- /Bank Statutory Tab -->
  <div id="payroll_benefits" class="pro-overview tab-pane fade">
    <div class="row pp-grid-row">
      <div class="col-lg-12 col-xl-6 d-flex">
        <div class="pp-card flex-fill">
          <div class="pp-header">
            <div class="pp-header-icon"><i class="fa-solid fa-file-invoice-dollar" aria-hidden="true"></i></div>
            <h3 class="pp-title">Payroll information</h3>
            <!-- <div class="pp-header-edit-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z" fill="#0C090A" fill-opacity="0.66"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z" fill="#0C090A" fill-opacity="0.66"/>
              </svg>
            </div> -->
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info">
              <li>
                <div class="title">Salary Grade</div>
                <div class="text">{{ salaryGrade?.grade || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Salary Type</div>
                <div class="text">{{ salaryType?.salary_type || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Hired Salary</div>
                <div class="text">
                  {{ payrollInformation?.hired_salary || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">Gross Salary</div>
                <div class="text">
                  {{ payrollInformation?.gross_salary || "N/A" }}
                </div>
              </li>
              <li v-for="(breakup, index) in salaryBreakups" :key="index"> 
                <div class="title">{{ breakup.label }}</div>
                <div class="text">
                  {{ breakup?.amount || "N/A" }}
                </div>
              </li>
              <!-- <li>
                <div class="title">Basic Salary</div>
                <div class="text">
                  {{ payrollInformation?.basic_salary || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">Medical/OPD Allowance</div>
                <div class="text">
                  {{ payrollInformation?.medical_allowance || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">Utility Allowance</div>
                <div class="text">
                  {{ payrollInformation?.utility_allowance || "N/A" }}
                </div>
              </li>
              <li>
                <div class="title">House Rent</div>
                <div class="text">
                  {{ payrollInformation?.house_rent || "N/A" }}
                </div>
              </li> -->
              <li>
                <div class="title">Salary Tax</div>
                <div class="text">
                  {{ payrollInformation?.salary_tax || "N/A" }}
                </div>
              </li>
              <!-- <li v-for="(raise, index) in salaryRaises" :key="raise.id">
                <div class="title">{{ index + 1 }} Salary Raise</div>
                <div class="text">{{ raise.salary_raise }}</div>
              </li> -->
              <li v-if="payrollInformation?.incentive != null">
                <div class="title">Incentive</div>
                <div class="text">
                  {{ payrollInformation?.incentive || "N/A" }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-6 d-flex">
        <div class="pp-card flex-fill">
          <div class="pp-header">
            <div class="pp-header-icon"><i class="fa-solid fa-receipt" aria-hidden="true"></i></div>
            <h3 class="pp-title">
              Salary Slips
            </h3>
            <!-- <div class="pp-header-edit-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.47079 2.47059H1.55556C0.696449 2.47059 0 3.208 0 4.11765V12.3529C0 13.2626 0.696449 14 1.55556 14H10.1112C10.9703 14 11.6667 13.2626 11.6667 12.3529V6.32502L8.62269 9.54813C8.35124 9.83554 8.00551 10.0315 7.62909 10.1112L5.54376 10.5528C4.18319 10.8409 2.98362 9.57076 3.25573 8.13016L3.6728 5.92218C3.74808 5.52361 3.93311 5.15756 4.20455 4.87015L6.47079 2.47059Z" fill="#0C090A" fill-opacity="0.66"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.1028 1.02541C13.0239 0.823914 12.9083 0.640843 12.7626 0.486661C12.617 0.332377 12.4441 0.209987 12.2538 0.126483C12.0635 0.0429798 11.8595 0 11.6535 0C11.4475 0 11.2435 0.0429798 11.0532 0.126483C10.8629 0.209987 10.69 0.332377 10.5444 0.486661L10.1198 0.93621L12.338 3.28492L12.7626 2.83537C12.9083 2.68119 13.0239 2.49811 13.1028 2.29661C13.1816 2.09511 13.2222 1.87913 13.2222 1.66101C13.2222 1.4429 13.1816 1.22692 13.1028 1.02541ZM11.2381 4.44956L9.01985 2.10086L5.30449 6.03479C5.2502 6.09227 5.2132 6.16548 5.19814 6.24519L4.78108 8.45317C4.72665 8.74129 4.96657 8.99532 5.23868 8.93769L7.324 8.4961C7.39929 8.48015 7.46843 8.44097 7.52272 8.38349L11.2381 4.44956Z" fill="#0C090A" fill-opacity="0.66"/></svg></div> -->
          </div>
          <div class="pp-body">
            <div class="table-responsive">
              <table class="table table-nowrap table-striped table-bordered pp-clean-table">
                <thead>
                  <tr>
                    <th>Year</th>
                    <th>Month</th>
                    <th>Division</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="salarySlips.length > 0">
                  <tr v-for="slip in salarySlips" :key="slip.id">
                    <td>{{ slip?.payroll?.year }}</td>
                    <td style="text-transform: capitalize">
                      {{ slip?.payroll?.month }}
                    </td>
                    <td>{{ slip?.payroll?.division_name?.name }}</td>
                    <td class="text-center">
                      <router-link
                        :to="`/payroll-management/payroll/salary-slip-user-view/${slip.id}`"
                      >
                        <img
                          :src="require(`@/assets/img/icons/eye.svg`)"
                          alt="Eye Icon"
                        />
                      </router-link>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="text-center">
                    <td colSpan="4">No Record</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row pp-grid-row">
      <div class="col-lg-12 col-xl-6 d-flex">
        <div class="pp-card flex-fill">
          <div class="pp-header">
            <div class="pp-header-icon"><i class="fa-solid fa-gift" aria-hidden="true"></i></div>
            <h3 class="pp-title">Benefits information</h3>
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info">
              <li>
                <div class="title">Provident Fund</div>
                <div class="text">{{ benefits?.provident_fund || "N/A" }}</div>
              </li>
              <li>
                <div class="title">EOBI</div>
                <div class="text">{{ benefits?.eobi || "N/A" }}</div>
              </li>
              <li>
                <div class="title">Company Transport</div>
                <div class="text">
                  {{ benefits?.company_transport ? "Yes" : "No" }}
                </div>
              </li>
              <li>
                <div class="title">Health Insurance</div>
                <div class="text">
                  {{ benefits?.health_insurance ? "Yes" : "No" }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-6 d-flex">
        <div class="pp-card flex-fill">
          <div class="pp-header">
            <div class="pp-header-icon"><i class="fa-solid fa-circle-info" aria-hidden="true"></i></div>
            <h3 class="pp-title">Other information</h3>
          </div>
          <div class="pp-body">
            <ul class="employee-personal-info">
              <li>
                <div class="title">Employee Card Status</div>
                <div class="text">
                  {{
                    payrollInformation.other_benefit?.employee_card_status
                      ? "Yes"
                      : "No"
                  }}
                </div>
              </li>
              <li>
                <div class="title">Health Insurance Card Status</div>
                <div class="text">
                  {{
                    payrollInformation?.other_benefit
                      ?.health_insurance_card_status
                      ? "Yes"
                      : "No"
                  }}
                </div>
              </li>
              <li>
                <div class="title">Discount Card</div>
                <div class="text">
                  {{
                    payrollInformation?.other_benefit?.discount_card_status
                      ? "Yes"
                      : "No"
                  }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row pp-grid-row">
      <div class="col-lg-12 col-xl-6 d-flex">
        <div class="pp-card flex-fill">
          <div class="pp-header">
            <div class="pp-header-icon"><i class="fa-solid fa-landmark" aria-hidden="true"></i></div>
            <h3 class="pp-title">EOBI</h3>
          </div>
          <div class="pp-body">
            <div class="table-responsive sticky-summary-table">
              <table class="table table-nowrap table-striped table-bordered pp-clean-table">
                <thead>
                  <tr style="background-color: #fff;">
                    <th>Year</th>
                    <th>Month</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in reversedEobiProvident" :key="item.id">
                    <td>{{ item.payroll.year }}</td>
                    <td>{{ item.payroll.month }}</td>
                    <td>{{ item.eobi }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>Total</td>
                    <td></td>
                    <td>{{ this.eobiSum }}</td>
                  </tr>

                  <tr>
                    <td>Company Contribution</td>
                    <td></td>
                    <td>{{ this.eobiSum * 5 }}</td>
                  </tr>

                  <tr>
                    <td>Grand Total</td>
                    <td></td>
                    <td>{{ this.eobiSum + this.eobiSum * 5 }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-6 d-flex">
        <div class="pp-card flex-fill">
          <div class="pp-header">
            <div class="pp-header-icon"><i class="fa-solid fa-piggy-bank" aria-hidden="true"></i></div>
            <h3 class="pp-title">Provident Fund</h3>
          </div>
          <div class="pp-body">
            <div class="table-responsive sticky-summary-table">
              <table class="table table-nowrap table-striped table-bordered pp-clean-table">
                <thead>
                  <tr style="background-color: #fff;">
                    <th>Year</th>
                    <th>Month</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in reversedEobiProvident" :key="item.id">
                    <td>{{ item.payroll.year }}</td>
                    <td>{{ item.payroll.month }}</td>
                    <td>{{ item.provident_fund }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>Total</td>
                    <td></td>
                    <td>{{ this.providentSum }}</td>
                  </tr>

                  <tr>
                    <td>Company Contribution</td>
                    <td></td>
                    <td>{{ this.providentSum }}</td>
                  </tr>

                  <tr>
                    <td>Grand Total</td>
                    <td></td>
                    <td>{{ this.providentSum + this.providentSum }}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row pp-grid-row">
      <div class="col-lg-12 col-xl-6 d-flex">
        <div class="pp-card flex-fill">
          <div class="pp-header">
            <div class="pp-header-icon"><i class="fa-solid fa-building-columns" aria-hidden="true"></i></div>
            <h3 class="pp-title">
              Account Details
            </h3>
            <!-- <div class="pp-header-edit-icon"></div> -->
          </div>
          <div class="pp-body">
            <div class="table-responsive">
              <table class="table table-nowrap table-striped table-bordered pp-clean-table">
                <thead>
                  <tr>
                    <th>Branch Name</th>
                    <th>Account Title</th>
                    <th>Account No</th>
                    <th>IBAN</th>
                    <th>Branch Code</th>
                    <th>Branch Address</th>
                  </tr>
                </thead>
                <tbody v-if="accounts?.length > 0">
                  <tr v-for="account in accounts" :key="account">
                    <td>{{ account.branch_name }}</td>
                    <td>{{ account.account_title }}</td>
                    <td>{{ account.account_no }}</td>
                    <td>{{ account.iban }}</td>
                    <td>{{ account.branch_code }}</td>
                    <td>{{ account.branch_address }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="6">No Data</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xl-6 d-flex">
        <div class="pp-card flex-fill">
          <div class="pp-header">
            <div class="pp-header-icon"><i class="fa-solid fa-chart-line" aria-hidden="true"></i></div>
            <h3 class="pp-title">
              Increment History
            </h3>
            <!-- <div class="pp-header-edit-icon"></div> -->
          </div>
          <div class="pp-body">
            <div class="table-responsive">
              <table class="table table-nowrap table-striped table-bordered pp-clean-table">
                <thead>
                  <tr>
                    <th>Increment</th>
                    <th>Increment Amount</th>
                    <th>Salary Adjustment Type</th>
                    <th>Increment Date</th>
                  </tr>
                </thead>
                <tbody v-if="salaryRaises?.length > 0">
                  <tr v-for="raise in salaryRaises" :key="raise">
                    <td>{{ raise?.increment }}</td>
                    <td>{{ raise?.salary_raise }}</td>
                    <td>
                      {{
                        raise?.raise_type?.split("_")?.join(" ")?.toUpperCase()
                      }}
                    </td>
                    <td>{{ raise?.increment_date }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td class="text-center" colspan="4">No Data</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EmployeeSalaryService from "@/services/EmployeeSalaryService";
import EmployeeAccountDetailService from "@/services/EmployeeAccountDetailService";
import EmployeeBenefitService from "@/services/EmployeeBenefitService";
import PayrollService from "@/services/PayrollService";
import SalarySlipsService from "@/services/SalarySlipsService";

export default {
  data() {
    return {
      payrollInformation: {},
      salarySlips: [],
      salaryRaises: [],
      salaryBreakups: [],
      salaryType: {},
      salaryGrade: {},
      accounts: [],
      benefits: {},
      eobiProvident: [],
      eobiSum: 0,
      providentSum: 0,
    };
  },
  props: ["userId"],
  methods: {
    async fetchSalarySlips() {
      try {
        const id = this.userId || this.$store.state.auth.user.employee_id;
        const response = await SalarySlipsService.getEmployeeWiseSalarySlips(
          id,
        );
        this.salarySlips = (response.data || []).filter((el) => el?.is_published);
      } catch (error) {
        console.log("error fetching salary slips", error);
        this.salarySlips = [];
      }
    },
  },
  computed: {
    grossSalary() {},
    reversedEobiProvident() {
      return [...this.eobiProvident].reverse();
    },
  },
  async created() {
    try {
      const response = await EmployeeSalaryService.getSalaryInformation(
        this.userId || this.$store.state.auth.user.employee_id,
      );

      const responseAccount = await EmployeeAccountDetailService.getDetails(
        this.userId || this.$store.state.auth.user.employee_id,
      );
      const responseBenefit = await EmployeeBenefitService.getDetails(
        this.userId || this.$store.state.auth.user.employee_id,
      );
      this.payrollInformation = response.data;

      const responseEOBI = await PayrollService.getEobiProvident(
        this.userId || this.$store.state.auth.user.employee_id,
      );

      this.fetchSalarySlips();

      let eobiSum = 0;
      let providentSum = 0;

      this.eobiProvident = responseEOBI?.data || [];

      this.eobiProvident?.forEach((el) => {
        if (Number(el?.eobi)) {
          eobiSum += Number(el?.eobi);
        }

        if (Number(el?.provident_fund)) {
          providentSum += Number(el?.provident_fund);
        }
      });

      this.eobiSum = eobiSum;
      this.providentSum = providentSum;

      this.accounts = responseAccount?.data?.account_details || [];
      this.salaryRaises = this.payrollInformation?.salary_raises || [];
      this.salaryBreakups = this.payrollInformation?.breakups || [];
      this.salaryType = this.payrollInformation?.salary_type || {};
      this.salaryGrade = this.payrollInformation?.salary_grade || {};
      this.benefits = responseBenefit?.data || {};
    } catch (error) {
      console.log("Error fetching", error);
      this.salarySlips = [];
      this.eobiProvident = [];
      this.accounts = [];
      this.salaryRaises = [];
      this.salaryBreakups = [];
      this.salaryType = {};
      this.salaryGrade = {};
      this.benefits = {};
    }
  },
};
</script>

<style scoped>
.pp-card {
  border: 1px solid #d8dde3;
  border-radius: 18px;
  overflow: hidden;
  background: #fff;
}

.pp-header {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 12px;
  padding: 30px 30px 20px 20px;
  background: #fff;
}

.pp-header-icon {
  width: 45px;
  height: 45px;
  border-radius: 7px;
  background: color-mix(in srgb, var(--primary-color) 15%, #fff);
  box-shadow: 0 0 0 10px color-mix(in srgb, var(--primary-color) 8%, #fff);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.pp-header-icon i {
  font-size: 20px;
  color: var(--primary-color);
}

.pp-header-edit-icon {
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: color-mix(in srgb, var(--primary-color) 10%, #fff);
  margin-left: auto;
  box-shadow: 0 0 0 6px color-mix(in srgb, var(--primary-color) 4%, #fff);
}

.pp-title {
  margin: 0;
  padding-left: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #12161c;
}

.pp-body { padding: 8px 20px 30px; }

.employee-personal-info li {
  border-bottom: 1px dashed #e4e8ec;
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.employee-personal-info li:last-child { border-bottom: 0; }
.employee-personal-info .title { color: #707783; font-size: 12px; }
.employee-personal-info .text { color: #3e434d; font-size: 12px; text-align: right; }

.table { margin-bottom: 0; }
.table th { background: transparent; font-size: 12px; color: #626a78; border: 0; border-bottom: 1px dashed #e4e8ec; font-weight: 500; padding: 10px 0; }
.table td { font-size: 12px; color: #3e444f; border: 0; border-bottom: 1px dashed #e4e8ec; padding: 10px 0; }
.table-bordered > :not(caption) > * > * { border: 0 !important; }
.pp-clean-table.table-bordered > :not(caption) > * {
  border-width: 0 !important;
}
.pp-clean-table.table-bordered > :not(caption) > * > * {
  border-width: 0 !important;
}
.pp-body .table tr:last-child td { border-bottom: 0; }
.pp-body .pp-clean-table > tbody > tr:nth-of-type(odd) > * { background: transparent !important; }
.pp-body .pp-clean-table > tbody > tr:nth-of-type(even) > * { background: transparent !important; }
.pp-body .pp-clean-table > thead > tr > * { background-color: transparent !important; }
.pp-body .pp-clean-table > tbody > tr > * { background-color: transparent !important; }
.pp-body .pp-clean-table tbody tr { background: transparent !important; }
.pp-body .pp-clean-table thead th {
  border-top: 0 !important;
  border-bottom: 1px dashed #e4e8ec !important;
}
.pp-body .pp-clean-table tbody tr:first-child td { border-top: 0 !important; }
.pp-body .pp-clean-table { border-top: 0 !important; }
.pp-body .pp-clean-table,
.pp-body .pp-clean-table thead,
.pp-body .pp-clean-table tbody,
.pp-body .pp-clean-table tr {
  border-top: 0 !important;
}
.pp-body .pp-clean-table tbody td {
  border-bottom: 1px dashed #e4e8ec !important;
}
.pp-body .table > :not(caption) > * > * { box-shadow: none !important; }
.pro-overview .row { row-gap: 16px; }
.pp-grid-row {
  margin-left: -8px;
  margin-right: -8px;
  margin-top: -12px;
  margin-bottom: -12px;
}
.pp-grid-row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 12px;
  padding-bottom: 12px;
}

@media (max-width: 991.98px) { .pp-body { padding: 12px 14px 14px; } }

.sticky-summary-table {
  max-height: 420px;
  overflow-y: auto;
}

.sticky-summary-table table {
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
}

.sticky-summary-table thead {
  position: sticky;
  top: 0;
  z-index: 2;
}

.sticky-summary-table thead th {
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
  box-shadow: 0 1px 0 0 #dee2e6;
}

.sticky-summary-table tfoot {
  position: sticky;
  bottom: 0;
  z-index: 2;
}

.sticky-summary-table tfoot td {
  background-color: #fff;
  font-weight: 600;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -1px 0 0 #dee2e6;
}
</style>
